export const DeclarationLineMenuOnTapName = 'declarationLineMenuOnTapComponent';
